import styled from 'styled-components';

const AppContainer = styled.div`
  background-color: rgba(1, 1, 1, 0);
  margin-top: 0;
  
  @media only screen and (max-width: 40.625rem) {
    margin-top: 5.9rem;
  }
`;

const Content = styled.div`
  min-height: 100vh;
`;

export {
  AppContainer,
  Content,
};
